import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reportesDeCotizacionesPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    
    if(values.clientes !== 0 && values.clientes && values.clientes.length > 0){
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre+' '+valueCliente.apellidoPaterno+' '+valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            {text: 'Clientes:', style: 'subheader'},
            {text: textoFiltrado, style: 'textoChico'}
        ])
    }

    if(values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0){
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre + " " + valueVendedores.apellidoPaterno + " " + valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            {text: 'Vendedores:', style: 'subheader'},
            {text: textoFiltrado, style: 'textoChico'}
        ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            {text: textoFiltrado, style: 'textoChico'}
        ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            {text: `${cuentaMask(values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5) + " - " + values.unidadDeNegocio.nombre}`, style: 'textoChico'}
        ])
    }

    const formatFecha = (fecha, defaultText = "") => {
        if (!fecha) return defaultText;
        const m = moment(fecha, ["DD/MM/YYYY", "YYYY-MM-DD", moment.ISO_8601]);
        return m.isValid() ? m.locale('es').format('L') : defaultText;
    };

    let cotizaciones = []

    for(const item of values.cotizaciones){

        const esPrincipal = !!item.folio;

        if (esPrincipal) {
            const properties = item.colorStyle ? {background: item.colorStyle} : {}
            cotizaciones.push([
                {text: item.folio, style: 'textoTabla', alignment: 'left', bold: true}, 
                {text: formatFecha(item.fechaCotizacion, ""), style: 'textoTabla', alignment: 'center'}, 
                {text: item.proyecto || 'N/A', style: 'textoTabla', alignment: 'left'}, 
                {text: item.cliente || '', style: 'textoTabla', alignment: 'left', bold: true},
                {text: formatFecha(item.fechaVigencia, "No tiene"), style: 'textoTabla', alignment: 'center'},
                {text: item.totalPagar != null ? dineroDisabledMask(item.totalPagar) : '$ 0.00', style: 'textoTabla', alignment: 'right', bold: true},
                {text: item.estado || '', ...properties, style: 'textoTabla', alignment: 'left'},
                {text: item.vendedor || '', style: 'textoTabla', alignment: 'left'},
            ])
        } else {
            const nombreInsumo = item.cliente || item.descripcion || item.nombre || '';
            const totalInsumo = item.estado || item.totalPagar || item.precio || 0;

            cotizaciones.push([
                {text: '', style: 'textoTabla'}, 
                {text: item.fechaCotizacion, style: 'textoTabla'}, 
                {text: item.proyecto || '', style: 'textoTabla', alignment: 'left', color: '#555'}, 
                {text: `   • ${nombreInsumo}`, style: 'textoTabla', alignment: 'left', color: '#555555'}, 
                {text: '', style: 'textoTabla'}, 
                {text: parseFloat(totalInsumo) ? dineroDisabledMask(totalInsumo) : '', style: 'textoTabla', alignment: 'right', color: '#555555'}, 
                {text: '', style: 'textoTabla'}, 
                {text: '', style: 'textoTabla'}, 
            ])
        }
    }

    let totalCotizaciones = values.cotizaciones.reduce((acc, val) => {
        if (val.folio) {
            return acc + parseFloat(val.totalPagar || val.total || 0);
        }
        return acc;
    }, 0);

    cotizaciones.push([
        { text: 'TOTAL:', style: 'totalChico', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: dineroDisabledMask(totalCotizaciones), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, true, true], fillColor: '#cccccc' },
    ]);
    
    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},
            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              ...HeaderEmpresaCard(empresa, false,false,
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              }),
                          ]
      
                      ]
                  },
              },
              {
                text: "Reporte de Cotizaciones",
                style: "tableHeaderIzquierda",
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      }
                  }
                  
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: ["9%", "9%", "12%", "20%", "10%", "15%", "10%", "15%"],
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          [
                            {text: 'Folio', style: 'tituloTabla'},                    
                            {text: 'Fecha', style: 'tituloTabla'},
                            {text: 'Proyecto', style: 'tituloTabla'}, 
                            {text: 'Cliente', style: 'tituloTabla'},
                            {text: 'Vencimiento', style: 'tituloTabla'},
                            {text: 'Total', style: 'tituloTabla'},
                            {text: 'Estado', style: 'tituloTabla'},
                            {text: 'Vendedor', style: 'tituloTabla'},
                          ],
                          ...cotizaciones
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      }
                  }
              },
              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
              header: { fontSize: 9, bold: true },
              subheader: { fontSize: 8, bold: true },
              tableExample: { margin: [0, 5, 0, 5] },
              tablaSinMargen: { margin: [0, 0, 0, 0] },
              tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
              textoChico: { fontSize: 8 },
              tituloTabla: { fontSize: 8, bold: true, fillColor: '#cccccc', style: 'subheader', alignment: 'center', border: true },
              textoTabla: { fontSize: 8, italics: false },
              totalChico: { fontSize: 6, bold: true, fillColor: '#cccccc', alignment: 'right', border: true }
          },
          pageSize: 'LETTER',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};

export default reportesDeCotizacionesPdf;